// initial state
const state = {
    view: {
        register: null,
        upgradeChofer: null
    }
};

// getters
const getters = {
    view: (state, viewName) => state.view[viewName],
    registerData: (state) => state.view['register'],
    upgradeChoferData: (state) => state.view['upgradeChofer']
};

// actions
const actions = {
    set (store, data) {
        store.commit('SET_TEMP_CACHE', data);
    },
    reset (store, data) {
        store.commit('RESET_TEMP_CACHE', data);
    }
};

// mutations
const mutations = {
    SET_TEMP_CACHE (state, {key, subKey, data}) {
        if (subKey) {
            state[key][subKey] = data;
        } else {
            state[key] = data;
        }
    },
    RESET_TEMP_CACHE (state, {key, subKey}) {
        if (subKey) {
            state[key][subKey] = null;
        } else {
            state[key] = null;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/temp-cache.js